import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const TableWithHeaderContainer = styled.div`
  border: 1px solid ${DEFAULT_COLORS.sky.borderLight};
  border-radius: 4px;
  overflow: hidden;
  background: ${DEFAULT_COLORS.white};
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  padding: 0 1.5rem 1.5rem;
  background: ${DEFAULT_COLORS.white};
`;

export const TableWrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${DEFAULT_COLORS.surface.white};
  font-family: Roboto, ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  border-radius: 4px;
`;

export const TableRow = styled.tr`
  &:hover td {
    background: ${DEFAULT_COLORS.surface.lightest};
  }
`;

export const TableHeader = styled.th<{ width?: number }>`
  background: ${DEFAULT_COLORS.white};
  border-bottom: 1px solid ${DEFAULT_COLORS.surface.lighter};
  font-size: 14px;
  font-weight: 700;
  padding: 12px 16px;
  text-align: left;
  height: 48px;
  color: ${DEFAULT_COLORS.ink.base};
  white-space: nowrap;
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
`;

export const TableCell = styled.td`
  background: ${DEFAULT_COLORS.white};
  border-bottom: 1px solid ${DEFAULT_COLORS.surface.divider};
  color: ${DEFAULT_COLORS.ink.base};
  font-size: 14px;
  font-weight: 400;
  padding: 14px 16px;
  height: 48px;
`;

export const SortingIcons = styled.span`
  margin-left: 4px;
  font-size: 14px;
  color: ${DEFAULT_COLORS.sky.muted};
  align-self: center;
`;

export const NoDataContainer = styled.tr`
  padding-top: 24px;
  color: ${DEFAULT_COLORS.sky.darkest};

  td {
    padding: 50px 0;
    text-align: center;
    color: ${DEFAULT_COLORS.sky.dark};
  }
`;

export const PaginationButton = styled.button`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  background: ${DEFAULT_COLORS.white};
  border: 1px solid ${DEFAULT_COLORS.surface.lighter};
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: ${DEFAULT_COLORS.ink.base};
  min-width: 2rem;
  transition: all 0.15s ease-in-out;

  &:hover:not(:disabled) {
    background: ${DEFAULT_COLORS.surface.subtle};
    border-color: ${DEFAULT_COLORS.sky.border};
  }

  &:disabled {
    background: ${DEFAULT_COLORS.surface.lightest};
    color: ${DEFAULT_COLORS.sky.border};
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 1rem 1.5rem;
  border-top: 1px solid ${DEFAULT_COLORS.surface.lighter};
  background: ${DEFAULT_COLORS.white};
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const PageInfo = styled.span`
  font-size: 0.875rem;
  color: ${DEFAULT_COLORS.ink.base};
  padding: 0 0.5rem;
`;

export const PageSizeSelect = styled.select`
  padding: 0.5rem;
  border: 1px solid ${DEFAULT_COLORS.surface.lighter};
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background: ${DEFAULT_COLORS.white};
  color: ${DEFAULT_COLORS.ink.base};
  cursor: pointer;
  margin-left: 0.5rem;

  &:focus {
    outline: none;
    border-color: ${DEFAULT_COLORS.accent.primaryAlt};
  }
`;
